var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSllrOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4561_378455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.71192 2.61193C2.91649 1.84999 3.60713 1.32031 4.39605 1.32031H14.2553C15.4022 1.32031 16.2368 2.40854 15.9394 3.51624L13.2881 13.3914C13.0835 14.1534 12.3929 14.6831 11.6039 14.6831H1.74474C0.597798 14.6831 -0.236795 13.5948 0.060605 12.4871L2.71192 2.61193Z",
    fill: "#123B47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60368 6.40537C8.35114 6.40537 8.16624 6.65356 8.23389 6.89725L9.15387 10.3269C9.17642 10.4171 9.14485 10.4848 9.11328 10.5209C9.08172 10.5615 9.0276 10.6112 8.9329 10.6112H4.04886C3.87749 10.6112 3.72416 10.7285 3.67906 10.8955L3.28221 12.3801C3.21907 12.6238 3.39946 12.863 3.65201 12.863H8.9329C9.39289 12.863 9.85739 12.7547 10.2407 12.502C11.2058 11.8657 11.6072 10.7691 11.3276 9.7357L10.5113 6.68966C10.4662 6.5227 10.3129 6.40537 10.1415 6.40537H8.60368Z",
    fill: "url(#paint0_linear_4561_378455)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39964 9.61385C7.65219 9.61385 7.83709 9.37017 7.76944 9.12649L6.84946 5.69687C6.82691 5.60662 6.85848 5.53893 6.89004 5.50283C6.92161 5.46221 6.97573 5.41258 7.07043 5.41258H11.9545C12.1258 5.41258 12.2792 5.29525 12.3243 5.12828L12.7211 3.6391C12.7888 3.39542 12.6039 3.15625 12.3513 3.15625H7.07043C6.61044 3.15625 6.14594 3.26455 5.76261 3.51726C4.79753 4.15355 4.39617 5.25012 4.67126 6.28352L5.48752 9.32956C5.53262 9.49653 5.68595 9.61385 5.85732 9.61385H7.39964Z",
    fill: "url(#paint1_linear_4561_378455)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4561_378455",
    x1: 14.0044,
    y1: 5.68843,
    x2: 2.64368,
    y2: 5.68843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7EE82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EE8E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4561_378455",
    x1: 14.0044,
    y1: 5.68843,
    x2: 2.64368,
    y2: 5.68843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7EE82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EE8E9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4561_378455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSllrOrder);
export default __webpack_public_path__ + "e760152d3a06699853e08f44a5f9bb52.svg";
export { ForwardRef as ReactComponent };